document.addEventListener("DOMContentLoaded", function () {
    let galleryElements = document.querySelector(".carousel-gallery");
    if (galleryElements) {
        let gallerySplide = new Splide(".splide.carousel-gallery", {
            type: "slide",
            rewind: false,     // Don't jump to first when on last
            loop: false,     // Completely disables circular looping
            perPage: 3,
            autoplay: true,
            interval: 3000,
            arrows: false,
            pagination: true,
            gap: "1em",
            breakpoints: {
                576: {
                    perPage: 1,
                },
                768: {
                    perPage: 2,
                },
                992: {
                    perPage: 3,
                },
            },
        });

        gallerySplide.mount();
        // Move to previous slide (-1)
        document.querySelector(".custome_splide__arrow--prev").addEventListener("click", function () {
            gallerySplide.go("-1"); // Moves one slide back
        });

        // Move to next slide (+1)
        document.querySelector(".custome_splide__arrow--next").addEventListener("click", function () {
            gallerySplide.go("+1"); // Moves one slide forward
        });
    }

    const carouselSpotlightElement =
        document.querySelectorAll(".spotlight-splide");

    if (carouselSpotlightElement) {
        carouselSpotlightElement.forEach(function (splideElement) {
            new Splide(splideElement, {
                type: "slide",
                rewind: false,     // Don't jump to first when on last
                loop: false,     // Completely disables circular looping
                perPage: 3,
                gap: "2rem",
                pauseOnHover: true,
                pauseOnFocus: true,
                drag: false,
                breakpoints: {
                    992: {
                        perPage: 2,
                    },
                    768: {
                        perPage: 1,
                    },
                },
                pagination: true, // Enable dots
                arrows: true, // Enable navigation
                classes: {
                    arrows: "splide__arrows custom-arrows",
                    arrow: "splide__arrow",
                    prev: "splide__arrow--prev",
                    next: "splide__arrow--next",
                    pagination: "splide__pagination custom-dots",
                    page: "splide__pagination__page",
                },
            }).mount();
        });
    }

    let credibilityElement = document.querySelector(".splide.credibility_slider");

    if (credibilityElement) {
        let autoSlideAttr = credibilityElement.getAttribute("data-auto");
        let perPageAttr = credibilityElement.getAttribute("data-perPage");
        let autoSlide = autoSlideAttr.trim().toLowerCase() === "true";
        let perPageLg = Math.floor(perPageAttr.trim());
        let perPageMd = Math.max(Math.floor(perPageLg / 2), 3);
        let perPageSm = Math.max(Math.floor(perPageLg / 3), 2);

        let credibilitySplide = new Splide(".splide.credibility_slider", {
            type: "loop",
            perPage: 4,
            arrows: false,
            pagination: false,
            gap: "1em",
            autoScroll: { speed: 0.5, pauseOnHover: false },

            fixedHeight: 60,
            mediaQuery: "min",
            autoplay: true,
            focus: "center",
            interval: 10000,
            breakpoints: {
                0: {
                    perPage: 2,
                },
                380: {
                    perPage: 3,
                },
                576: {
                    perPage: 4,
                },
                768: {
                    perPage: 5,
                },
                991: {
                    perPage: 4,
                },
                // 1200: {
                //   perPage: 5,
                // },
                // 1400: {
                //   perPage: 5,
                // },
            },
        });
        // credibilitySplide.mount();
        credibilitySplide.mount(autoSlide ? window.splide.Extensions : "");
    }

    const carouselElements = document.querySelectorAll(".carousel_slider");

    if (carouselElements) {
        carouselElements.forEach(function (splideElement) {
            new Splide(splideElement, {
                type: "slide",
                rewind: false,     // Don't jump to first when on last
                loop: false,     // Completely disables circular looping
                perPage: 3,
                autoplay: false,
                interval: 3000,
                arrows: true,
                pagination: false,
                breakpoints: {
                    1024: { perPage: 3 },
                    768: { perPage: 2 },
                    576: { perPage: 1 },
                },
            }).mount();
        });
    }

});
